var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterbankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 225.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
    fill: "#0060a9",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231 2239 c-88 -17 -163 -79 -205 -169 -21 -45 -21 -54 -24 -1058 l-3 -1013 1013 3 1013 3 60 30 c64 32 121 96 146 163 11 30 14 220 17 1045 l2 1007 -987 -1 c-544 -1 -1008 -5 -1032 -10z m1509 -1013 l0 -614 -27 -6 c-43 -9 -1184 -196 -1194 -196 -11 0 -12 1230 -1 1230 4 1 270 45 592 99 322 54 595 99 608 100 l22 1 0 -614z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterbankIcon);
export default __webpack_public_path__ + "static/media/interbank-icon.542ebb8b57ba7221a2d89c5b8de951d8.svg";
export { ForwardRef as ReactComponent };